import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  ViewContainerRef,
} from '@angular/core';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, map, Observable, of } from 'rxjs';
import { makeEnvironment } from '../environments/make-environment';
import { LoaderComponent } from './components/common/loader/loader.component';
import { CustomInjector } from './helpers/custom-injector';
import { DynamicComponent } from './helpers/dynamic-component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoaderComponent],
})
export class AppComponent {
  private environment = makeEnvironment();
  public loading$: Observable<boolean> = of(false);

  constructor(
    public injector: Injector,
    public viewContainerRef: ViewContainerRef,
    private router: Router,
  ) {
    DynamicComponent.setViewContainerRef(this.viewContainerRef);
    CustomInjector.setup(this.injector);

    this.loading$ = this.router.events.pipe(
      filter(
        (e) =>
          e instanceof NavigationStart ||
          e instanceof NavigationEnd ||
          e instanceof NavigationCancel ||
          e instanceof NavigationError,
      ),
      map((e) => e instanceof NavigationStart),
    );

    document.title = `${this.environment.PROJECT_NAME} ${this.environment.PROJECT_VERSION}`;
  }
}
